import { SmartPillData } from 'owa-smart-pill';
import SmartPillsRenderingStrategy from './SmartPillsRenderingStrategy';
import integrateSmartFeatureArrangement from './utils/integrateSmartFeatureArrangement';
import selectSmartFeatureArrangement from './utils/selectSmartFeatureArrangement';

export const defaultRenderingStrategy: SmartPillsRenderingStrategy = {
    selectPills: (pills: SmartPillData[]) => {
        return integrateSmartFeatureArrangement(pills, selectSmartFeatureArrangement(pills));
    },
};

export default defaultRenderingStrategy;
